import React, { Component } from 'react';
import { string, func, bool } from 'prop-types';

import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import classNames from 'classnames';
import styles from './styles.scss';

const SERIES_TYPE_BASE = 'base';
const SERIES_TYPE_ADDITION = 'addition';
const SERIES_TYPE_GUIDELINE = 'guideline';

const HOVER_OUT = 'out';
const HOVER_OVER = 'over';

export default class SeriesSelector  extends Component {
  static propTypes = {
    className: string,
    baseColor: string,
    additionColor: string,
    guidelineColor: string,
    baseLabel: string,
    additionLabel: string,
    guidelineLabel: string,
    showBaseSerie: bool,
    showAdditionSerie: bool,
    showGuidelineSerie: bool,
    showBaseOption: bool,
    hoverBaseSeries: bool,
    hoverAdditionSeries: bool,
    hoverGuidelineSeries: bool,
    onSelectionChange: func,
    handleSerieSelectionHover: func
  }

  static defaultProps = {
    baseColor: '#00BCD4',
    additionColor: '#3F51B5',
    guidelineColor: '#CF87DF',
    guidelineLabel: 'Ads',
    baseLabel: 'Web Visits',
    additionLabel: 'Ad Visits',
    showBaseSerie: true,
    showAdditionSerie: true,
    showGuidelineSerie: true,
    showBaseOption: true,
    hoverBaseSeries: false,
    hoverAdditionSeries: false,
    hoverGuidelineSeries: false,
  }

  handleVisibilityHover = targetInfo => event => {
    const {
      hoverGuidelineSeries,
      hoverBaseSeries,
      hoverAdditionSeries,
      handleSerieSelectionHover
    } = this.props;

    if (handleSerieSelectionHover) {
      const newHoverInfo = {
        hoverBaseSeries,
        hoverAdditionSeries,
        hoverGuidelineSeries
      };

      const hoverStatus = targetInfo.type === HOVER_OVER;
      switch (targetInfo.target) {
        case SERIES_TYPE_GUIDELINE:
          if (newHoverInfo.hoverGuidelineSeries !== hoverStatus) {
            newHoverInfo.hoverGuidelineSeries = hoverStatus;
            handleSerieSelectionHover(newHoverInfo);
          }
          break;
        case SERIES_TYPE_BASE:
          if (newHoverInfo.hoverBaseSeries !== hoverStatus) {
            newHoverInfo.hoverBaseSeries = hoverStatus;
            handleSerieSelectionHover(newHoverInfo);
          }
          break;
        case SERIES_TYPE_ADDITION:
          if (newHoverInfo.hoverAdditionSeries !== hoverStatus) {
            newHoverInfo.hoverAdditionSeries = hoverStatus;
            handleSerieSelectionHover(newHoverInfo);
          }
          break;
      }
    }
  }

  handleVisibilityChanges = target => event => {
    const {
      showGuidelineSerie,
      showBaseSerie,
      showAdditionSerie,
      onSelectionChange
    } = this.props;

    if (onSelectionChange) {
      // const newSelectionInfo = {
      //   showGuidelineSerie,
      //   showBaseSerie,
      //   showAdditionSerie

      // };

      // switch (target) {
      //   case SERIES_TYPE_GUIDELINE:
      //     newSelectionInfo.showGuidelineSerie = !newSelectionInfo.showGuidelineSerie;
      //     break;
      //   case SERIES_TYPE_BASE:
      //     newSelectionInfo.showBaseSerie = !newSelectionInfo.showBaseSerie;
      //     break;
      //   case SERIES_TYPE_ADDITION:
      //     newSelectionInfo.showAdditionSerie = !newSelectionInfo.showAdditionSerie;
      //     break;
      // }

      let newSelectionInfo;
      switch (target) {
        case SERIES_TYPE_GUIDELINE:
          newSelectionInfo = {showGuidelineSerie: !showGuidelineSerie};
          break;
        case SERIES_TYPE_BASE:
          newSelectionInfo = {showBaseSerie: !showBaseSerie};
          break;
        case SERIES_TYPE_ADDITION:
          newSelectionInfo = {showAdditionSerie: !showAdditionSerie};
          break;
      }

      onSelectionChange(newSelectionInfo);
    }
  }

  drawLabel (text, color) {
    return <span style={{ fontSize: 14, color }}>{text}</span>;
  }


  render () {
    const {
      className,
      baseColor,
      additionColor,
      guidelineColor,
      baseLabel,
      additionLabel,
      guidelineLabel,
      showBaseSerie,
      showAdditionSerie,
      showGuidelineSerie,
      showBaseOption,
      hoverBaseSeries,
      hoverAdditionSeries,
      hoverGuidelineSeries
    } = this.props;

    const isHovering = hoverBaseSeries || hoverAdditionSeries || hoverGuidelineSeries;

    return (
      <FormGroup row className={classNames(className, styles.seriesSelector)}>
        {showBaseOption && <div
          className={classNames({[styles.lowlight]: isHovering && !hoverBaseSeries})}
          onMouseOut={this.handleVisibilityHover({ target: SERIES_TYPE_BASE, type: HOVER_OUT })}
          onMouseOver={this.handleVisibilityHover({ target: SERIES_TYPE_BASE, type: HOVER_OVER })}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={showBaseSerie}
                value={SERIES_TYPE_BASE}
                style={{ color: baseColor }}
                onChange={this.handleVisibilityChanges(SERIES_TYPE_BASE)}
                data-test="seriesCheckboxBase"
              />
            }
            label={ this.drawLabel(baseLabel, baseColor) }
          />
        </div>}
        <div
          className={classNames({[styles.lowlight]: isHovering && !hoverAdditionSeries})}
          onMouseOut={this.handleVisibilityHover({ target: SERIES_TYPE_ADDITION, type: HOVER_OUT })}
          onMouseOver={this.handleVisibilityHover({ target: SERIES_TYPE_ADDITION, type: HOVER_OVER })}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={showAdditionSerie}
                value={SERIES_TYPE_ADDITION}
                style={{ color: additionColor }}
                onChange={this.handleVisibilityChanges(SERIES_TYPE_ADDITION)}
                data-test="seriesCheckboxAdd"
              />
            }
            label={ this.drawLabel(additionLabel, additionColor) }
          />
        </div>
        <div
          className={classNames({[styles.lowlight]: isHovering && !hoverGuidelineSeries})}
          onMouseOut={this.handleVisibilityHover({ target: SERIES_TYPE_GUIDELINE, type: HOVER_OUT })}
          onMouseOver={this.handleVisibilityHover({ target: SERIES_TYPE_GUIDELINE, type: HOVER_OVER })}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={showGuidelineSerie}
                value={SERIES_TYPE_GUIDELINE}
                style={{ color: guidelineColor }}
                onChange={this.handleVisibilityChanges(SERIES_TYPE_GUIDELINE)}
                data-test="seriesCheckboxGuideline"
              />
            }
            label={ this.drawLabel(guidelineLabel, guidelineColor) }
          />
        </div>
      </FormGroup>
    );
  }
}
